
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		// baohuo-yuanchuang
		let APIS = {
			getSpeakerSearchList: `get /apis/baohuo-yuanchuang/speaker/store/search`, // 获取发音人
			getSpeakerEmotionList: `get /apis/baohuo-yuanchuang/v1/speaker/getSpeakerEmotionList`, // 获取所有风格 含该风格的表情包
			getPersonalSetting: `get /apis/baohuo-account/v1/user/personalSetting/get`, // 获取用户个性化设置
			//获取生图工程结果
			getPromptResult: `get /apis/baohuo-yuanchuang/compose/video/task/getPromptResult`, // 
			createAndUpdateTask: `post /apis/baohuo-yuanchuang/compose/video/task/create`, // 
			taskSubmit: `post /apis/baohuo-yuanchuang/compose/video/task/submit`, // 
			createDefaultTask:`get /apis/baohuo-yuanchuang/compose/video/task/createDefaultTask`, 
			getDetailInfo: `get /apis/baohuo-yuanchuang/compose/video/task/getDetailInfo`,
			oneClickComposeAudio:`post /apis/baohuo-yuanchuang/oneClickCompose/dub`,
			// 重新生图
			renewImg: `post /apis/baohuo-yuanchuang/video/compose/async/request/renew`,
			uploadImage:`post /apis/baohuo-yuanchuang/v1/resources/?contentType=image/jpeg`,
			// 获取重新生图
			getRenewImageStatus: `get /apis/baohuo-yuanchuang/video/compose/renew/status`,
			// 查询生图列表
			getQueryComposeImgList: {
				custom: true,
				url: (data:any)=>`/apis/baohuo-yuanchuang/video/compose/queryComposeImageNewList/${data.originImageId}`,
				method: 'get'
			},
			// 交换图片
			exchangeImg: `get /apis/baohuo-yuanchuang/compose/video/task/exchangeImage`,
			// 批量设置图片编辑
			batchExchangeImage:`post /apis/baohuo-yuanchuang/compose/video/task/batchExchangeImage`,
			// 字体列表
			getFontList: `get /apis/baohuo-yuanchuang/font/list`,
			downloadRecord: `post /apis/baohuo-yuanchuang/font/downloadRecord/save`,
			//添加图片微动参数
			updateImageMovePrompt:`post /apis/baohuo-yuanchuang/compose/video/task/updatePrompt`,
			// 合成图片
			composeCover: `post /apis/baohuo-yuanchuang/compose/cover/submit`,
			// 查询合成图片
			queryComposeResult: `get /apis/baohuo-yuanchuang/compose/cover/queryResult`,
			ttsSplitWord: { // 分词
				custom: true,
				url: '/tts/frontend/word',
				method: 'post'
			},
			updatePersonalSetting: { // 分词
				custom: true,
				url: '/apis/baohuo-account/v1/user/personalSetting/update',
				method: 'post'
			},
			// 微调重新生图
			adjustmentGenerate: `post /apis/baohuo-yuanchuang/video/compose/async/request/correct`,
			// 微调图片状态查询
			adjustmentQueryStatus: `get /apis/baohuo-yuanchuang/video/compose/correct/status`,
			// 获取微调生图列表
			getAdjustmentList: {
				custom: true,
				url: (data) => `/apis/baohuo-yuanchuang/video/compose/queryCorrectImageList/${data.originImageId}`,
				method: 'get'
			},
			// 查询合成导出视频状态
			getExportVideoStatus: {
				custom: true,
				url: data => `/apis/baohuo-yuanchuang/compose/video/task/getStatus?ww_token=${data.ww_token}&taskId=${data.taskId}`,
				method: 'post'
			},
			// 查询生成图片次数
			qryReGenImageList: `get /apis/baohuo-yuanchuang/video/compose/qryReGenImageList`,
			// 查询会员权益
			queryMemberLeftRight:'get /apis/baohuo-account/v1/memberCenter/queryMemberLeftRight',
			/**********************短剧相关*************************/
			// 创建短剧默认任务
			createShortPlayDefaultTask: `get /apis/baohuo-yuanchuang/short/play/video/task/createDefaultTask`,
			// 创建或更新短剧任务信息，用来更新封面信息&bgm信息&导出前调用
			updateShortPlayTask: `post /apis/baohuo-yuanchuang/short/play/video/task/create`,
			// 导出短剧
			shortPlayTaskSubmit: `post /apis/baohuo-yuanchuang/short/play/video/task/submit`,
			// 导出解压视频
			exportDownStressSubmit: `post /apis/baohuo-yuanchuang/compress/video/material/submit`,
			// 更新短剧中间生成结果，用来更新segments
			updateShortPlayPrompt: `post /apis/baohuo-yuanchuang/short/play/video/task/updatePrompt`,
			// 获取多音字
			getWordList: `post /tts/getWordList`,
			// 数字读法
			getTnList: `get /tts/tnList`,
			// 获取文字模板列表
			getTextTemplateListApi: `get /apis/baohuo-yuanchuang/textTemplate/list`,
			// 获取生成记录
			getBrainRecordList: `post /apis/baohuo-yuanchuang/intelligent/tool/record/list`,
			// 删除生成记录
			deleteRecord: {
				custom: true,
				url: (data:any)=>`/apis/baohuo-yuanchuang/intelligent/tool/record/delete/${data.recordId}`,
				method: 'delete'
			},
			// 生成智能标题
  		generateTitleApi: `post /apis/baohuo-yuanchuang/intelligent/tool/generate/title`,
			// 查询生成状态
			queryRecordStatus: `get /apis/baohuo-yuanchuang/intelligent/tool/record/status`,
			// 查询智能生图次数
			queryGenImgLimitCount: `get /apis/baohuo-yuanchuang/intelligent/tool/queryGenImgLimitCount`,
			// 智能生图
			generateText2Img: 'post /apis/baohuo-yuanchuang/intelligent/tool/generate/text2Img',
			// 更新智能文案结果
			updateArticleAi: `post /apis/baohuo-yuanchuang/oneClick/article/update`,
			// 获取讲真用户是否显示内容开关
			getSwitch: 'get /apis/baohuo-yuanchuang/intelligent/tool/querySwitch',
			// 获取用户信息
			getUserInfo: 'get /apis/baohuo-account/v1/user',
			// 抖音安全检测相关
			checkDouyinTextContent: `post /h5/tt/checkContent`,
			checkDouyinImgContent: `post /h5/tt/checkImage`,
			getDouyinAccessToken: `get /h5/tt/getAccessToken`,
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"videoEditorPage"
			})
		}